import React, { useEffect, useContext } from "react";
import {
  IntroductionPage,
  IntroductionScreen,
  ProfileImageContainer,
  ProfileImage,
  IntroData,
  DownloadBtn,
} from "./introduction.styles";

//libs
import Starback from "starback";
import Lottie from "react-lottie";
import Typewriter from "typewriter-effect";
import { Icon } from "@iconify/react";
import { Fade } from "react-reveal";
import IntroImage from "../../components/introImage/introImage.component";

import { ThemeContext } from "../../theme.context";

//assets
import profileLottie from "../../assets/lotties/profileCircle2.json";

const Introduction = () => {
  const profileLottieOptions = {
    loop: true,
    autoplay: true,
    animationData: profileLottie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  // useEffect(() => {
  //   const canvas = document.getElementById("canvas");
  //   const wi = window.innerWidth;
  //   const hi = window.innerHeight - 50;
  //   const starback = new Starback(canvas, {
  //     width: wi,
  //     height: hi,
  //     // type: "dot",
  //     type: 'dot',
  //     quantity: 150,
  //     starSize: [1,4],
  //     direction: 20,
  //     starColor: 'white',
  //     randomOpacity: [0.7, 1],
  //     backgroundColor: 'transparent',
  //     // quantity: 100,
  //     // direction: 0,
  //     backgroundColor: ["#3957D2"], //"#223CA5",
  //     // randomOpacity: true,
  //   });
  // }, []);

  const downLoadResume = () => {
    window.location.href = "http://localhost/src/assets/ShivamGavandiCV.pdf";
  };

  const { darkMode } = useContext(ThemeContext);

  return (
    <IntroductionPage>
      {/* <canvas id="canvas"></canvas> */}
      <IntroductionScreen>
        <ProfileImageContainer>
          {/* <Lottie options={profileLottieOptions} width="600px" height="600px" />
          <ProfileImage url="https://wallpaperaccess.com/full/4525391.jpg" /> */}
          <IntroImage />
        </ProfileImageContainer>
        <IntroData dark={darkMode}>
          <Fade right>
            <h1 className="intro-header">Hello, I am Shivam</h1>
          </Fade>
         <Fade top delay={500} >
         <div className="subtitle-text">
            <Typewriter
              options={{
                strings: [
                  "Web developer",
                  "App developer",
                  "Designer",
                  "Problem Solver",
                ],
                autoStart: true,
                loop: true,
                delay: 80,
              }}
            />
          </div>
         </Fade>

          <Fade right delay={1000}>
            <DownloadBtn
              href="files/ShivamGavandiCV.pdf"
              target="_blank"
              dark={darkMode}
            >
              Download CV <Icon icon="bxs:download" fontSize="1.2em" />
            </DownloadBtn>
            {/* <a href="files/ShivamGavandiCV.pdf" target="_blank">download</a> */}
          </Fade>
        </IntroData>
      </IntroductionScreen>
    </IntroductionPage>
  );
};

export default Introduction;
